export const kpiRuptureHeader = [
  {
    group: 'Periodo',
    columns: [
      {
        name: 'Data',
        id: 'data-execucao-id',
        show: false
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'empresa-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'ID',
        id: 'fornecedor-codigo-id',
        show: false
      },
      {
        name: 'Descrição',
        id: 'fornecedor-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'CD/Loja',
    columns: [
      {
        name: 'Código',
        id: 'cd-loja-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'cd-loja-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Gerente',
    columns: [
      {
        name: 'Categoria',
        id: 'gerente-categoria-id',
        show: false
      },
      {
        name: 'Produto',
        id: 'gerente-produto-id',
        show: false
      }
    ]
  },
  // {
  //   group: 'Mundo',
  //   columns: [
  //     {
  //       name: 'Código',
  //       id: 'mundo-codigo-id',
  //       show: false
  //     },
  //     {
  //       name: 'Nome',
  //       id: 'mundo-nome-id',
  //       show: false
  //     }
  //   ]
  // },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Código',
        id: 'categoria-compacta-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'categoria-compacta-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Categoria',
    columns: [
      {
        name: 'Código',
        id: 'categoria-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'categoria-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Status',
    columns: [
      {
        name: 'Nome',
        id: 'status-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Nome',
        id: 'curva-abc-nome-id',
        show: false
      }
    ]
  },

  {
    group: 'Ruptura 0 Dias',
    columns: [
      {
        name: 'Total SKUs',
        id: 'ruptura-one-total-id',
        show: true
      },
      {
        name: 'SKUs Ruptura',
        id: 'ruptura-one-sku-id',
        show: true
      },
      {
        name: 'Ruptura (%)',
        id: 'ruptura-one-day-id',
        show: true
      }
    ]
  },
  {
    group: 'Ruptura 10 Dias',
    columns: [
      {
        name: 'Total SKUs',
        id: 'ruptura-ten-total-id',
        show: true
      },
      {
        name: 'SKUs Ruptura',
        id: 'ruptura-ten-sku-id',
        show: true
      },

      {
        name: 'Ruptura (%)',
        id: 'ruptura-ten-days-id',
        show: true
      }
    ]
  }
]
